import { render, staticRenderFns } from "./form-queries-query-details.vue?vue&type=template&id=023ab645&scoped=true&"
import script from "./form-queries-query-details.vue?vue&type=script&lang=js&"
export * from "./form-queries-query-details.vue?vue&type=script&lang=js&"
import style0 from "./form-queries-query-details.vue?vue&type=style&index=0&id=023ab645&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "023ab645",
  null
  
)

component.options.__file = "form-queries-query-details.vue"
export default component.exports